// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1fqiP","itemTitle":"ClientEmergencyInfo_itemTitle__1dPie","itemText":"ClientEmergencyInfo_itemText__1WatS"};